<div class="media profile-media" (click)="toggleDropdown($event)" style="cursor: pointer;">
    <img
        class="b-r-10"
        src="assets/images/dashboard/profile.png"
        width="35"
        alt=""
    />
    <div class="media-body">
        <span>{{ currentUser?.last_name }} {{ currentUser?.first_name }}</span>
        <p class="mb-0 font-roboto">
            {{ currentUser?.email }}<i class="middle fa fa-angle-down"></i>
        </p>
    </div>
</div>
<ul class="profile-dropdown-menu" *ngIf="isDropdownOpen">
    <li (click)="openFormAccount(accountV, currentUser)">
        <i [attr.data-feather]="'user'"></i>&nbsp;<span>Mon compte</span>
    </li>
    <li (click)="openFormPassword(passwordV)">
        <i [attr.data-feather]="'lock'"></i>&nbsp;<span>Mot de passe</span>
    </li>
    <!-- <li (click)="openFormAuthenticationTwoFactors(doubleAuthentication)">
        <i [attr.data-feather]="'shield'"></i>&nbsp;<span
            >2 FA
            <span
                class="badge"
                [ngClass]="
                    authenticationTwoFactors ? 'badge-success' : 'badge-danger'
                "
                [ngStyle]="{ 'font-size': '12px' }"
            >
                {{ authenticationTwoFactors ? 'Activé' : 'Desactivé' }}
            </span>
        </span>
    </li> -->
    <li (click)="logout()" class="logout-li">
        <i [attr.data-feather]="'log-in'"></i>&nbsp;<span>Déconnexion</span>
    </li>
</ul>
<!---------------------PASSWORD FORM----------------------------->
<ng-template #passwordV let-modal>
    <form [formGroup]="passwordForm">
        <div class="modal-header">
            <h4 class="modal-title" id="modal-basic-title">
                Modification Mot de passe
            </h4>
            <button
                type="button"
                class="btn-close"
                aria-label="Close"
                (click)="hideForm()"
            ></button>
        </div>
        <div class="modal-body" novalidate>
            <div class="form-group mb-4">
                <label>
                    <b>Ancien Mot de passe</b>
                </label>
                <p-password
                    formControlName="old_password"
                    [feedback]="false"
                    [toggleMask]="true"
                    styleClass="p-password p-component p-inputwrapper p-input-icon-right"
                ></p-password>
            </div>
            <div class="form-group mb-4">
                <label>
                    <b>Nouveau Mot de passe</b>
                </label>
                <p-password
                    formControlName="new_password"
                    [feedback]="false"
                    [toggleMask]="true"
                    styleClass="p-password p-component p-inputwrapper p-input-icon-right"
                ></p-password>
                <ng-container
                    *ngIf="
                        submitted &&
                        passwordForm.get('new_password')?.errors &&
                        !passwordForm
                            .get('new_password_confirmation')
                            ?.hasError('invalidPassword')
                    "
                >
                    <span
                        class="fs-6 lh-1 text-danger fst-italic font-italic"
                        *ngIf="
                            passwordForm.get('new_password')?.invalid ||
                            passwordForm.get('new_password')?.errors['required']
                        "
                    >
                        Une lettre majuscule, une lettre minuscule, un chiffre
                        et un caractère spécial.
                    </span>
                </ng-container>
            </div>
            <div class="form-group mb-3">
                <label>
                    <b>Confirmer nouveau mot de passe</b>
                </label>
                <p-password
                    formControlName="new_password_confirmation"
                    [feedback]="false"
                    [toggleMask]="true"
                    styleClass="p-password p-component p-inputwrapper p-input-icon-right"
                ></p-password>
                <ng-container
                    *ngIf="
                        submitted &&
                        passwordForm.get('new_password_confirmation')?.errors &&
                        !passwordForm
                            .get('new_password_confirmation')
                            ?.hasError('invalidPassword')
                    "
                >
                    <span
                        class="fs-6 lh-1 text-danger fst-italic font-italic"
                        *ngIf="
                            passwordForm.get('new_password_confirmation')
                                ?.invalid ||
                            passwordForm.get('new_password_confirmation')
                                ?.errors['required']
                        "
                    >
                        Doit etre identique au nouveau mot de passe.
                    </span>
                </ng-container>
            </div>
        </div>

        <div class="modal-footer">
            <div>
                <button type="button" class="btn btn-hide" (click)="hideForm()">
                    Fermer
                </button>
            </div>
            <div>
                <button
                    type="button"
                    class="btn btn-save"
                    (click)="handleUpdatePassword()"
                    [disabled]="passwordForm.invalid"
                >
                    Valider
                </button>
            </div>
        </div>
    </form>
</ng-template>
<!---------------------ACCOUNT FORM----------------------------->
<ng-template #accountV let-modal>
    <form [formGroup]="accountForm">
        <div class="modal-header">
            <h4 class="modal-title" id="modal-basic-title">Mon Compte</h4>
            <button
                type="button"
                class="btn-close"
                aria-label="Close"
                (click)="hideFormAccount()"
            ></button>
        </div>
        <div class="modal-body" novalidate>
            <div class="form-group mb-3">
                <label>
                    <b>Nom complet<span class="text-danger">*</span></b>
                </label>
                <input type="text" formControlName="full_name" pInputText />
            </div>
            <div class="form-group mb-3">
                <label>
                    <b>Email<span class="text-danger">*</span></b>
                </label>
                <input type="text" formControlName="email" pInputText />
            </div>
            <div class="form-group mb-3">
                <label>
                    <b>Numéro de téléphone<span class="text-danger">*</span></b>
                </label>
                <p-inputMask
                    formControlName="phone_number"
                    mask="99-99-99-99-99"
                    placeholder="00-00-00-00-00"
                    styleClass="w-100"
                ></p-inputMask>
            </div>
            <div class="form-group mb-3">
                <label>
                    <b>Adresse<span class="text-danger">*</span></b>
                </label>
                <input type="text" formControlName="address" pInputText />
            </div>
        </div>
        <div class="modal-footer">
            <div>
                <button
                    type="button"
                    class="btn btn-hide"
                    (click)="hideFormAccount()"
                >
                    Fermer
                </button>
            </div>
            <div>
                <button
                    type="button"
                    class="btn btn-save"
                    (click)="handleUpdateAdmin()"
                    [disabled]="!accountForm.valid"
                >
                    Valider
                </button>
            </div>
        </div>
    </form>
</ng-template>

<ng-template #doubleAuthentication let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">
            <i class="pi pi-lock" style="font-size: 1.5rem"></i>
            Authentification à deux facteurs
        </h4>
        <button
            type="button"
            class="btn-close"
            aria-label="Close"
            (click)="hideForm()"
        ></button>
    </div>

    <div class="modal-body">
        <!-- Sous-titre avec switch aligné -->
        <!-- <div class="d-flex justify-content-between align-items-center mb-2">
            <div>
                <h6>Protégez votre compte avec un code supplémentaire</h6>
                <div class="container-fluid">
                    <div class="d-flex align-items-center">
                        <small class="text-muted">
                            Activer la double authentification de sécurité à votre compte en demandant un code
                            de validation envoyé par email lors de la connexion.
                        </small>
                        <p-inputSwitch [(ngModel)]="authenticationTwoFactors"
                            [disabled]="(loadingDoubleAuthentication$ | async) || (loadingUserAuth$ | async)"
                            (onChange)="onToggleAuthenticationTwoFactors($event)">
                        </p-inputSwitch>
                    </div>
                </div>
            </div>
        </div> -->

        <div class="d-flex justify-content-between align-items-center mb-2">
            <div>
                <h6 class="text-center">
                    Protégez votre compte avec un code supplémentaire
                </h6>
                <div>
                    <div
                        class="d-flex flex-column gap-3 align-items-center justify-content-center"
                    >
                        <small class="text-muted text-center">
                            Activer la double authentification de sécurité à
                            votre compte en demandant un code de validation
                            envoyé par email lors de la connexion.
                        </small>
                        <p-inputSwitch
                            [(ngModel)]="authenticationTwoFactors"
                            style="width: 65px"
                            [disabled]="
                                (loadingDoubleAuthentication$ | async) ||
                                (loadingUserAuth$ | async)
                            "
                            (onChange)="
                                onToggleAuthenticationTwoFactors($event)
                            "
                        >
                        </p-inputSwitch>
                    </div>
                </div>
            </div>
        </div>

        <div class="mt-3 text-center">
            <span
                class="badge authenticationTwoFactorsBadge"
                [ngClass]="
                    authenticationTwoFactors ? 'bg-success' : 'bg-secondary'
                "
            >
                {{ authenticationTwoFactors ? 'activé' : 'désactivé' }}
            </span>
        </div>
    </div>

    <div class="modal-footer">
        <button type="button" class="btn btn-hide" (click)="hideForm()">
            Fermer
        </button>
    </div>
</ng-template>
